import { sortBy } from 'lodash/fp';
import usdata from './usdata';
import international from './international';

const sort = sortBy(({ geography, longTitle }) => geography || longTitle);

export const denormalize = ({
  all = [],
  byId,
} = {}) => sort(all.map((x) => byId[x]));

export const navigationSelector = (ownProps) => {
  if ('international' === ownProps.match.params.category) {
    return international;
  }

  // Return US Data by default
  return usdata;
};

export default navigationSelector;



// WEBPACK FOOTER //
// ./app/selectors/navigation/index.js